import React, { Component } from "react";
import {
  Select as MuiSelect,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
} from "@mui/material";

export class Select extends Component {
  static defaultProps = {
    valueField: "id",
    labelField: "label",
  };

  handleSelect = (event) => {
    this.props.onChange(event.target.value);
  };

  render() {
    const {
      items,
      value,
      valueField,
      labelField,
      label,
      style, // eslint-disable-line no-unused-vars
      onChange, // eslint-disable-line no-unused-vars
      onBlur,
      errorText,
      disabled,
      ...rest
    } = this.props;

    return (
      <div className={`croField${errorText ? " croField--error" : ""}`}>
        <FormControl
          variant="outlined"
          size="small"
          fullWidth
          error={Boolean(errorText)}
          disabled={disabled}
        >
          {label && <InputLabel id={`${label}-label`}>{label}</InputLabel>}
          <MuiSelect
            labelId={`${label}-label`}
            value={value ?? ""}
            onChange={this.handleSelect}
            onBlur={onBlur}
            label={label}
            {...rest}
            MenuProps={{ ...(rest.MenuProps || {}), disablePortal: true, disableScrollLock: true }}
          >
            {items &&
              items.map((item, i) => (
                <MenuItem key={i} value={item[valueField]}>
                  {item[labelField]}
                </MenuItem>
              ))}
          </MuiSelect>
          {errorText && <FormHelperText>{errorText}</FormHelperText>}
        </FormControl>
      </div>
    );
  }
}

export default ({ input, meta: { touched, error }, ...rest }) => (
  <Select errorText={touched && error} {...input} {...rest} />
);
